module.exports = __webpack_public_path__ + "media/images/country_flags/gl-8999824c5abf6eee4919d0e14c7819f1.png";